var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('b-container',{staticClass:"marginal"},[_c('h2',[_vm._v("Aide")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }